<template>
    <div>
        <div class="mb-5">
            <div class="headline saPrimary--text"> {{ $t("admin.page.appearance.list.title") }}</div>
            <span class="body-1 greyDarken3--text">{{ $t("admin.page.appearance.list.subtitle") }}</span>
        </div>
      <v-card>
        <v-card-title>
            <div v-if="pages.length" class="title"><span>Total : </span><b>{{ pages.length }}</b></div>
        </v-card-title>
        <v-card-text class="px-0">
          <v-data-table
            :headers="table_headers"
            :items="pages"
            :loading="loading"
            v-bind:pagination.sync="pagination"
          >
            <template v-slot:items="props">
              <tr
                :style="{cursor: 'pointer'}"
                @click.stop="
                  $router.push({
                    name: 'AdminPageRoot',
                    params: {
                      page_id: props.item.id,
                    },
                  })
                "
              >
                <td class="text-xs-left subheading">{{ props.item.title['en'] }}</td>
                <td class="text-xs-left">{{ props.item.slug }}</td>
                <td class="text-xs-left">
                  <v-chip class="secondary secondary--text font-weight-medium" small outline>
                    {{
                    DEFINES.SCREENER_STATUS[props.item.published]
                    }}
                  </v-chip>
                </td>
                <td
                  class="text-xs-left"
                >{{ moment.utc(props.item.created_at).local().format('MMMM Do YYYY') }}</td>
                <td class="text-xs-center">
                  <v-tooltip slot="append" top color="white">
                    <v-btn
                      slot="activator"
                      icon
                      small
                      dark
                      @click.stop="
                        $router.push({
                          name: 'AdminPageRoot',
                          params: {
                            page_id: props.item.id,
                          },
                        })
                      "
                    >
                      <v-icon color="secondary">$vuetify.icons.rms_visibility</v-icon>
                    </v-btn>
                    <span class="greyDarken3--text body-1">
                      {{
                      $t('rms.tooltip.view')
                      }}
                    </span>
                  </v-tooltip>

                  <v-tooltip slot="append" top color="white">
                    <v-btn
                      slot="activator"
                      icon
                      small
                      dark
                      @click.stop="deleteConfirmation(props.item.id)"
                    >
                      <v-icon color="secondary">$vuetify.icons.rms_delete</v-icon>
                    </v-btn>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
  </template>
  <script>
  import { mapState, mapGetters } from "vuex";
  import ConfirmationDialog from "@/components/dialogBox/Confirmation";
  import i18n from "@/i18n";
  import { utcToTz } from "@/helper";

  export default {
    name: "PageList",
    data() {
      return {
        search: "",
        total: 0,
        pages: [],
        confirmation: false,
        loading: true,
        table_headers: [
          {
            text: i18n.t("page.list.table.header.title"),
            align: "left",
            sortable: true,
            value: "id"
          },
          {
            text: i18n.t("page.list.table.header.slug"),
            align: "left",
            sortable: false,
            value: "title"
          },
          {
            text: i18n.t("page.list.table.header.status"),
            align: "left",
            sortable: false,
            value: "published"
          },
          {
            text: i18n.t("page.list.table.header.created_on"),
            align: "left",
            sortable: true,
            value: "created_at"
          },
          {
            text: i18n.t("page.list.table.header.action"),
            align: "center",
            sortable: false,
            value: "action"
          }
        ],
        pagination: { sortBy: "title", descending: true, rowsPerPage: 5 },
        local_def_pages: {
          about: true,
          privacy: true,
          terms: true
        },
        deletePageId: null
      };
    },
    created() {
      this.getApiData();
    },
    computed: {
      ...mapState({
        list: state => state.page.list,
        company: state => state.company.company
      })
    },
    components: { ConfirmationDialog },
    methods: {
      async getApiData() {
        this.loading = true;
        try {
          var response = await this.$store.dispatch("adminPage/list", {});
          this.pages = response.pages
        } catch (error) {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: this.DEFINES.SNACKBAR_ERROR_COLOR
          });
        }
        this.loading = false;
      },

      deleteConfirmation(page_id) {
        this.deletePageId = page_id;
        this.confirmation = true;
      }
    }
  };
  </script>
